/**
 * @name store/modules/postals/index.js
 * @module app
 * 
 * @description 
 * The typescript store modules.
 * 
 * @project spotgig4app
 * @author Ryunosuke Oguri on 2017/05/20
 * Copyright © 2017年 Axis-motion. All rights reserved.
 */
import Postal from '../../../api/postal'
import * as types from './mutation-types'

const state = {
  address: {},
  success: {},
  error: {},
}

const getters = {
  address: state => state.address,
}

const actions = {
  getAddress ({ commit }, params) {
    return new Promise((resolve, reject) => {
      Postal.getAddress(params, response => {
        if ( response.data && response.data.error === null ) {
          commit(types.RECEIVE_ADDRESS, response.data.content)
          resolve(response)
        } else {
          commit(types.REQUEST_ERROR, response.data.error)
          reject(response.data.error)
        }
      }).catch((error) => {
        commit(types.REQUEST_ERROR, error)
        reject(error)
      })
    })
  },
}

const mutations = {
  [types.RECEIVE_ADDRESS] (state, address) {
    state.address = address
  },
  [types.REQUEST_SUCCESS] (state, messages) {
    state.success = { code: 200, messages: messages }
  },
  [types.REQUEST_ERROR] (state, payload) {
    state.error = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
